import { useEffect, useState, type ReactElement } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useToast } from '../toast-provider/utils/use-toast';
import { type UserInfo, UserInfoContext } from './user-info-context';
import { microsoftGraphApi } from '@/services/microsoft-graph-api/api';

interface UserInfoProviderProperties {
  readonly children: ReactElement;
}

export const UserInfoProvider = ({ children }: UserInfoProviderProperties): ReactElement => {
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const showToast = useToast();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    const loadUserInfo = async (): Promise<void> => {
      try {
        const user = await microsoftGraphApi.getUserInfo();

        setUserInfo(user);
      } catch {
        showToast({ message: 'Failed to load user information.', variant: 'error' });
      }
    };

    if (isAuthenticated) {
      void loadUserInfo();
    }
  }, [isAuthenticated, showToast]);

  return <UserInfoContext value={{ userInfo }}>{children}</UserInfoContext>;
};
